import set from "lodash/set";
import get from "lodash/get";
import isFunction from "lodash/isFunction";
import capitalize from "lodash/capitalize";

import { blank, filled, formatDate, formatCurrency } from "./utils";

export const formatValue = (value, item, options) => {
  const { default: defaultValue, type: cast, format: formatter } = options || {};

  if (formatter) {
    return formatter(value, item);
  }

  if (filled(defaultValue) && blank(value)) {
    value = isFunction(defaultValue) ? defaultValue(value, item) : defaultValue;
  }

  if (blank(value)) {
    return value;
  }

  switch (cast) {
    case "date":
      return formatDate(value);
    case "title":
      return capitalize(value);

    case "datetime":
      return formatDate(value, true);

    case "currency":
      return formatCurrency(value);

    default:
      return value;
  }
};

const formatedCache = {};

export const formartedPathName = (path) => {
  if (path in formatedCache) {
    return formatedCache[path];
  }
  const fieldNameParts = String(path).split(".");

  fieldNameParts.push(`_formated_${fieldNameParts.pop()}`);

  const formatedPath = fieldNameParts.join(".");

  formatedCache[path] = formatedPath;

  return formatedPath;
};

export default (item, fields) => {
  if (blank(fields)) {
    return item;
  }

  for (let fieldName in fields) {
    let currentValue = get(item, fieldName);

    set(item, formartedPathName(fieldName), formatValue(currentValue, item, fields[fieldName]));
  }
  return item;
};
